module.exports = __webpack_public_path__ + "static/banner-9d835543827404360f582974ed76c54d.png";